import styled from "styled-components";

export const ModalLink = styled.a`
  background-color: transparent;
  color: #0074b5;
  padding: 0;
  margin: 0;
`;
